import { useState } from "react";
import SEO from "../components/SEO";

const faqs = [
  { q: "How do I create an account?", a: "Click 'Sign Up' in the navigation bar. You'll need to provide your business information, NPI number, and DEA number for verification. Our team will review your application and activate your account." },
  { q: "How does pricing work?", a: "We offer competitive wholesale pricing on all our products. Prices are visible only to verified, logged-in customers. Contact our sales team for volume discounts and custom pricing arrangements." },
  { q: "What is DSCSA compliance?", a: "The Drug Supply Chain Security Act (DSCSA) is a federal law that requires tracking of pharmaceutical products through the supply chain. Premier Pharma is fully DSCSA compliant, providing complete transaction documentation for all shipments." },
  { q: "What categories of products do you carry?", a: "We carry Pharmaceuticals, Animal Health products, Medical/Surgical supplies, Caps & Tabs, and Diabetic Supplies. Browse our full catalog in the Products section." },
  { q: "How do I place an order?", a: "Once your account is verified, browse our product catalog, add items to your cart, and proceed to checkout. You can include a PO number and shipping address with your order." },
  { q: "What software solutions do you offer?", a: "We offer ScriptTrack, a comprehensive platform for in-office dispensing, DSCSA compliance, inventory management, and e-prescribing. Visit our Software page for pricing and details." },
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(f => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <>
      <SEO
        title="Pharmacy Wholesaler FAQs"
        description="Answers to common questions about Premier Pharma — accounts, wholesale pricing, DSCSA compliance, product categories, ordering, and ScriptTrack software."
        jsonLd={faqJsonLd}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "FAQs", path: "/faq" },
        ]}
      />
      <section className="py-20 bg-gradient-to-br from-background to-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-accent text-sm font-semibold uppercase tracking-wider">FAQs</span>
          <h1 className="text-4xl font-bold text-primary mt-2 mb-8">Frequently Asked Questions</h1>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="card cursor-pointer" onClick={() => setOpenIndex(openIndex === i ? null : i)}>
                <div className="flex justify-between items-center">
                  <h3 className="font-semibold text-primary pr-4">{faq.q}</h3>
                  <svg className={`w-5 h-5 text-accent flex-shrink-0 transition-transform ${openIndex === i ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
                <div hidden={openIndex !== i}>
                  <p className="text-gray-600 text-sm mt-3 pt-3 border-t border-gray-100">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
